module.exports = __webpack_public_path__ + "img/h-page4-5.2187c5c4.png";